import request from "@/utils/request";
export const queryPage = "/icps/system/sign/basics/plan/QuerySignOfPage";
/*分页获取混凝土列表（三方）*/
export function betonGet_beton_page(data) {
  return request({
    url: "/icps/system/sign/intelligent/tripleReport/beton/get_beton_page",
    method: "post",
    data,
  });
}
/*产品的添加入库（检测类型 1出场检测 2三方检测-混凝土检测 3 批次检测 4 三方检测-原物料检测*/
export function saveOneProduct(data) {
  return request({
    url: "/icps/system/sign/intelligent/selfreport/saveOneProduct",
    method: "post",
    data,
  });
}
/*配合比的添加入库（检测类型 1出场检测 2三方检测-混凝土检测 3 批次检测 4 三方检测-原物料检测*/
export function saveOneRaw(data) {
  return request({
    url: "/icps/system/sign/intelligent/selfreport/saveOneRaw",
    method: "post",
    data,
  });
}
/*分页获取过期自检报告（检测类型 1出场检测 2三方检测-混凝土检测 3 批次检测 4 三方检测-原物料检测*/
export function selfreportqueryPage(data) {
  return request({
    url: "/icps/system/sign/intelligent/selfreport/queryPage",
    method: "post",
    data,
  });
}
/*过期自检报告-复制到库（通用）*/
export function selfreportupdateOne(data) {
  return request({
    url: "/icps/system/sign/intelligent/selfreport/updateOne",
    method: "post",
    data,
  });
}
/*分页获取自检报告（三方和出场*/
export function selfreportqueryChecked(data) {
  return request({
    url: "/icps/system/sign/intelligent/selfreport/queryChecked",
    method: "post",
    data,
  });
}
/*批量删除（三方和出场*/
export function selfreportdelectMany(data) {
  return request({
    url: "/icps/system/sign/intelligent/selfreport/delectOne",
    method: "post",
    data,
  });
}
/*修改页面——获取检验结果（通用）*/
export function selfdetectionqueryByReportId(data) {
  return request({
    url: "/icps/system/sign/intelligent/selfdetection/queryByReportId",
    method: "post",
    data,
  });
}
/*修改页面——保存检验结果（三方和出场*/
export function selfdetectionupdateMany(data) {
  return request({
    url: "/icps/system/sign/intelligent/selfdetection/updateMany",
    method: "post",
    data,
  });
}
/*选择自检报告绑定到配合比（三方和出场*/
export function planSelfsaveMany(data) {
  return request({
    url: "/icps/system/sign/intelligent/planSelf/saveMany",
    method: "post",
    data,
  });
}
//以上是产品的接口---------------------------------------------------

/*获取订单配合比特殊要求和水泥品牌*/
export function disclosequeryOne(data) {
  return request({
    url: "/icps/system/sign/cloudSell/engineeringManagement/mixQueryOneByid",
    method: "post",
    data,
  });
}
/*修改订单配合比特殊要求和水泥品牌*/
export function discloseupdateOne(data) {
  return request({
    url: "/icps/system/sign/cloudSell/engineeringManagement/updateMixRatio",
    method: "post",
    data,
  });
}
/*返回交工配合比名称列表*/
export function workMixRatioqueryListByGeneral(data) {
  return request({
    url: "/icps/system/sign/intelligent/workMixRatio/queryList",
    method: "post",
    data,
  });
}
/*获取交工配合比详细配置*/
export function workMixRatiogetRatioDetail(data) {
  return request({
    url: "/icps/system/sign/intelligent/workMixRatio/getRatioDetail",
    method: "post",
    data,
  });
}
/*分页显示已分配配合比的订单列表*/
export function dataMixqueryPlan(data) {
  return request({
    url: "/icps/system/sign/intelligent/dataMix/queryPlan",
    method: "post",
    data,
  });
}
/*查询已分配配合比订单详细配合比配置*/
export function dataMixgetRatioDetail(data) {
  return request({
    url: "/icps/system/sign/intelligent/dataMix/getRatioDetail",
    method: "post",
    data,
  });
}
/*为订单添加配合比--------*/
export function dataMixsaveMession(data) {
  return request({
    url: "/icps/system/sign/intelligent/dataMix/saveMession",
    method: "post",
    data,
  });
}
/*修改订单配合------*/
export function dataMixupdateMession(data) {
  return request({
    url: "/icps/system/sign/intelligent/dataMix/updateMession",
    method: "post",
    data,
  });
}
/*为订单添加/修改配合比*/
export function dataMixsaveOrUpdate(data) {
  return request({
    url: "/icps/system/sign/intelligent/dataMix/saveOrUpdate",
    method: "post",
    data,
  });
}
/*打开配置比显示默认数据*/
export function dataMixgetByPlan(data) {
  return request({
    url: "/icps/system/sign/intelligent/dataMix/getByPlan",
    method: "post",
    data,
  });
}
/*清空自检报告*/
export function clearPlanReport(data) {
  return request({
    url: "/icps/system/sign/intelligent/dataMix/clearPlanReport",
    method: "post",
    data,
  });
}
/*工程列表下拉*/
export function queryEngineeringList() {
  return request({
    url: "/icps/system/sign/cloudSell/engineeringManagement/queryEngineeringList",
    method: "get",
  });
}
//以上是配合比的接口---------------------------------------------------

/*分页获取原物料列表(批次)*/
export function makequeryByRaw(data) {
  return request({
    url: "/icps/system/sign/intelligent/make/queryByRaw",
    method: "post",
    data,
  });
}
/*分页获取原物料列表（三方原物料*/
export function rawgetPageByRaw(data) {
  return request({
    url: "/icps/system/sign/intelligent/tripleReport/raw/getPageByRaw",
    method: "post",
    data,
  });
}
/*分页获取自检报告（三方原物料和批次*/
export function selfreportqueryPageRaw(data) {
  return request({
    url: "/icps/system/sign/intelligent/selfreport/queryPageRaw",
    method: "post",
    data,
  });
}
//以上是配合比检验报告的接口---------------------------------------------------
/*批次检验数据*/
export function checkoutQuerypage(data) {
  return request({
    url: "/icps/system/sign/intelligent/make/querypage",
    method: "post",
    data,
  });
}
/*获取上一次的配合比数据*/
export function getByHistoryPlan(data) {
  return request({
    url: "/icps/system/sign/intelligent/dataMix/getByPlan",
    method: "post",
    data
  });
}
/*获取历史开盘工程*/
export function queryPlanEngineeringName(data) {
  return request({
    url: "/icps/system/sign/intelligent/dataMix/queryPlanEngineeringName",
    method: "post",
    data
  });
}
/*自检报告过期*/
export function expireReport(data) {
  return request({
    url: "/icps/system/sign/intelligent/selfreport/expireReport",
    method: "post",
    data
  });
}
/*自己报告复制入库新*/
export function saveNewByCopy(data) {
  return request({
    url: "/icps/system/sign/intelligent/selfreport/saveNewByCopy",
    method: "post",
    data
  });
}
/*获取未过期/已过期检验报告接口*/
export function queryPageRaw(data) {
  return request({
    url: "/icps/system/sign/intelligent/selfreport/queryPageRaw",
    method: "post",
    data
  });
}
/*自检报告生成*/
export function saveResport(data) {
  return request({
    url: "/icps/system/sign/intelligent/selfreport/saveResport",
    method: "post",
    data
  });
}
/*获取最新原物料对应的自检报告*/
export function getNewDetaHistory(data) {
  return request({
    url: "/icps/system/sign/intelligent/dataMix/getNewDetaHistory",
    method: "post",
    data,
    timeout:180000,
  });
}
